var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"captura_container"},[_c('br'),_c('br'),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.setarModal()}}},[_vm._v("EXIBIR MODAL")]),_c('br'),_c('br'),_c('br')]),_c('ModalSolicitacoes',{attrs:{"exibirModal":_vm.exibirModal},on:{"setarModal":(valor) => _vm.setarModal(valor)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }